(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bb-order-process"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bb-order-player')) {
    customElements.define('bb-order-player', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        const video = this.querySelector('video');
        const button = this.querySelector('button');
        const error = this.querySelector('.bo-error');
        if (!video || !button || !error) return;
        video.controls = false;
        button.hidden = false;
        button.addEventListener('click', async () => {
          button.hidden = true;
          error.hidden = true;
          video.controls = true;
          try { await video.play(); video.focus(); }
          catch { error.hidden = false; }
        });
        video.addEventListener('ended', () => {
          video.controls = false;
          button.querySelector('.bo-play-label').textContent = this.dataset.replay;
          button.hidden = false;
        });
        video.addEventListener('error', () => {
          button.hidden = true;
          video.controls = true;
          error.hidden = false;
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bb-product-information"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bb-product-tabs')) {
  customElements.define('bb-product-tabs', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.panels = Array.from(this.querySelectorAll('.bb-tabs__panel'));
      this.nav = this.querySelector('.bb-tabs__nav');
      this.active = 0;
      this.buttons = this.panels.map((panel,index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'bb-tabs__tab';
        button.id = panel.id + '-tab';
        button.setAttribute('role','tab');
        button.setAttribute('aria-controls',panel.id);
        button.textContent = panel.querySelector('summary > span').textContent;
        button.addEventListener('click',() => this.select(index));
        button.addEventListener('keydown',event => {
          let next = index;
          if (event.key === 'ArrowRight') next = (index + 1) % this.buttons.length;
          else if (event.key === 'ArrowLeft') next = (index - 1 + this.buttons.length) % this.buttons.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = this.buttons.length - 1;
          else return;
          event.preventDefault();
          this.select(next);
          this.buttons[next].focus();
        });
        this.nav.append(button);
        return button;
      });
      this.nav.setAttribute('role','tablist');
      this.media = matchMedia('(min-width: 750px)');
      this.update = () => this.layout();
      this.media.addEventListener('change',this.update);
      this.layout();
      this.templateTarget = this.querySelector('[data-bb-artwork-templates]');
      this.templateClick = event => {
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const link = event.target.closest('a[data-bb-template-shortcut]');
        if (!link || !this.templateTarget || link.hash !== '#' + this.templateTarget.id) return;
        event.preventDefault();
        if (window.location.hash !== link.hash) history.pushState(history.state, '', link.hash);
        this.showTemplates(true);
      };
      this.templateHash = () => {
        if (this.templateTarget && window.location.hash === '#' + this.templateTarget.id) this.showTemplates(false);
      };
      document.addEventListener('click', this.templateClick);
      window.addEventListener('hashchange', this.templateHash);
      this.templateHash();
    }
    disconnectedCallback() {
      this.media?.removeEventListener('change',this.update);
      document.removeEventListener('click', this.templateClick);
      window.removeEventListener('hashchange', this.templateHash);
      this.ready = false;
      this.nav?.replaceChildren();
    }
    showTemplates(animate) {
      const panel = this.templateTarget.closest('.bb-tabs__panel');
      const index = this.panels.indexOf(panel);
      if (index < 0) return;
      this.select(index);
      this.templateTarget.focus({ preventScroll: true });
      this.templateTarget.scrollIntoView({ block: 'start', behavior: animate && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'instant' });
    }
    select(index) { this.active = index; this.layout(); }
    layout() {
      const desktop = this.media.matches;
      this.toggleAttribute('data-desktop',desktop);
      this.buttons.forEach((button,index) => {
        button.setAttribute('aria-selected',String(index === this.active));
        button.tabIndex = index === this.active ? 0 : -1;
      });
      this.panels.forEach((panel,index) => {
        panel.hidden = desktop && index !== this.active;
        panel.open = index === this.active;
        if (desktop) {
          panel.setAttribute('role','tabpanel');
          panel.setAttribute('aria-labelledby',this.buttons[index].id);
          panel.tabIndex = 0;
        } else {
          panel.removeAttribute('role');
          panel.removeAttribute('aria-labelledby');
          panel.removeAttribute('tabindex');
        }
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bb-ref-process"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bb-process-player')) {
    customElements.define('bb-process-player', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        const video = this.querySelector('video');
        const button = this.querySelector('button');
        const error = this.querySelector('.bp-error');
        if (!video || !button) return;
        video.id = button.getAttribute('aria-controls');
        video.controls = false;
        button.hidden = false;
        button.addEventListener('click', async () => {
          button.hidden = true;
          error.hidden = true;
          video.controls = true;
          try { await video.play(); video.focus(); }
          catch { video.controls = true; error.hidden = false; }
        });
        video.addEventListener('ended', () => {
          video.controls = false;
          button.querySelector('.bp-play-label').textContent = this.dataset.replay;
          button.hidden = false;
        });
        video.addEventListener('error', () => {
          button.hidden = true;
          video.controls = true;
          error.hidden = false;
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
